import React from "react";

const TargetBlank = ({children, className, href, style}: { children: any, className?: string, href?: string, style?: any }) => {
    return (
        <a className={className} style={style} target='_blank' rel='noopener noreferrer' href={href}>{children}</a>
    );
};
export default TargetBlank;
